/* eslint-disable eqeqeq */
import { Autocomplete, createFilterOptions } from '@mui/material';
import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import { CssTextField } from 'components/helper/helperInut';
import { UserpilotHook } from './LabelUserpilotHook';

type OptionType = any;

interface Props {
  id?: string;
  clg?: boolean;
  borderless?: boolean;
  label?: string;
  option: OptionType;
  mdCol?: string;
  name?: string;
  values?: any;
  isValid?: boolean;
  feedback?: any;
  defautlValues?: any;
  disabled?: boolean;
  placeholder?: string;
  form?: any;
  className?: string;
  multiple?: boolean;
  logo?: string;
  hidden?: boolean;
  borderType?: number;
  onChange?: (val: any) => void;
  onInputChange?: any;
  onCreateNew?: (val: any) => void;
  transformValue?: (val: string) => string;
  isMissing?: any;
  isCMLogo?: boolean;
  isCuScuLogo?: boolean;
  isTestCsuLogo?: boolean;
  tooltips?: string;
  setLabelHight?: boolean;
  labelClass?: string;
  labelCustom?: any;
  /** Stable Userpilot spotlight hook. Do not derive from class names. */
  dataUp?: string;
}

const AutocompleteInput = React.memo((props: Props) => {
  const [inputValue, setInputValue] = React.useState('');
  const [forceEmpty, setForceEmpty] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const arrValues = React.useMemo(() => {
    return (Array.isArray(props?.values || []) ? props.values : [props.values]) ?? [];
  }, [props.values]);

   React.useEffect(() => {
    setIsLoading(false);
   },[]);

  React.useEffect(() => {
    if (props.option && props.option?.length && props.values === undefined && !forceEmpty) {
      props.form &&
        props.form.setFieldValue(
          props.name,
          typeof props.option[0] === 'string' ? props.option[0] : props.option[0]?.value
        );
    }
  }, [props.values, props.option, props.form, props.name, forceEmpty]);

  const handleChange = (event: any, newValue: any) => {
    try {
      if (newValue === null || newValue === '' || newValue === undefined) {
        setForceEmpty(true);
      } else {
        setForceEmpty(false);
      }
      props.form?.setFieldValue(props.name, newValue);
      props.onChange && props.onChange(newValue);
    } catch (ex) {
      // skip
      //console.log('Error in handleChange:', ex);
    }
  };

  const handleInputChange = (event: React.SyntheticEvent | null, value: string) => {
    try {
      let val: string = value || '';
      if (props.transformValue) {
        val = props.transformValue(value || '');
      }
      setInputValue(val);
      props.onInputChange && props.onInputChange(val);
    }
    catch(ex){
      console.error('Error in handleInputChange:', ex);
      setInputValue('');
    }
  };

  const showLabel = Boolean(props.label) || props.labelCustom !== undefined;

  return props.hidden ? null : (
    <FormControl
      id={props.id}
      disabled={props.disabled}
      error={!!props.isMissing}
      className={props.className}
      data-up={showLabel ? undefined : props.dataUp}
    >
      {props.labelCustom!==undefined ? (
      <label htmlFor={props.id || props.name} className = {props.labelClass} >
        {props.label}
        {props.labelCustom && (props.labelCustom)}
        <UserpilotHook dataUp={props.dataUp} />
      </label>       
      ) : (
        <div
          style={
            props.setLabelHight
              ? {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  minHeight: '40px',
                }
              : { marginBottom: '2px' }
          }
        >

          <FormLabel
            className={`select-label label-14px`}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              fontSize: '14px',
              margin: props.setLabelHight ? 0 : undefined,
              marginBottom: '1px !important',
              backgroundColor: props.isMissing ? '#FFEBEB' : '',
            }}
          >
            <span>{props.label}</span>
            {(props?.logo && props.setLabelHight) && (
              <FormLabel className={`csu-logo-select-input-float-right ${props?.logo ?? ''}`.trim()} />
            )}
            <UserpilotHook dataUp={props.dataUp} />
          </FormLabel>
          {(props?.logo && !props.setLabelHight && !props.isTestCsuLogo && !props.isCuScuLogo) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null}
          {(props?.logo && props.isTestCsuLogo) ? <span className={`csu-logo-sat-text-float-right ${props?.logo ?? null}`}></span> : null}
          {(props?.logo && props.isCuScuLogo) ? <span className={`csu-logo-cu-csu-citizen-right ${props?.logo ?? null}`}></span> : null}
        </div>
      )}

      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
        }}
      >
        <Autocomplete
          filterOptions={props.multiple ? undefined : createFilterOptions({ trim: true })}
          size="medium"
          multiple={props.multiple ?? false}
          id={props.name}
          loading={isLoading}
          aria-label={props.label}
          disabled={props.disabled}
          renderInput={(params) => (
            <CssTextField 
              {...params} 
              placeholder={props.placeholder}
              inputProps={{
                ...params.inputProps,
                ...(!showLabel && props.dataUp ? { 'data-up': props.dataUp } : {}),
              }}
              sx={{
                fontSize: '15px',
                backgroundColor: '#fff',
                '& .MuiOutlinedInput-root': {
                  fontSize: '15px',
                  backgroundColor: '#fff',
                }
              }}
            />
          )}
          options={props.option}
          onChange={handleChange}
          onInputChange={handleInputChange}
          inputValue={inputValue}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox checked={selected} size="small" />
              {option}
            </li>
          )}
          value={props.multiple ? (forceEmpty ? [] : arrValues) : (forceEmpty ? null : (props.values || null)) }
          noOptionsText={
            props.onInputChange && inputValue && (
              <button 
                onClick={() => props.onCreateNew && props.onCreateNew(inputValue)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  cursor: 'pointer',
                  padding: '8px 16px',
                  width: '100%',
                  textAlign: 'left'
                }}
              >
                Create new: {inputValue}
              </button>
            )
          }
          freeSolo
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
        />
      </div>
      {(props.feedback || props.isMissing) && (
        <FormHelperText sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '1rem' }}>
          {props.feedback && <span>{props.feedback}</span>}
          {props.isMissing && <span style={{ color: '#d32f2f' }}>This field is required.</span>}
        </FormHelperText>
      )}
    </FormControl>
  );
});

export default AutocompleteInput;
